module.exports = __webpack_public_path__ + "img/9.e5f6780e.png";